import { sendAction } from '../core/action.js';

var PROJECTS;
(function (PROJECTS) {
    PROJECTS["guides"] = "guidesInGame";
    PROJECTS["inGameNews"] = "newsInGame";
    PROJECTS["playTogether"] = "playTogetherInGame";
    PROJECTS["profile"] = "playerStats";
    PROJECTS["clans"] = "clansInGame";
    PROJECTS["clanInvites"] = "clanInvites";
    PROJECTS["clanWars"] = "clanWarsInGame";
    PROJECTS["warehouse"] = "warehouseInGame";
    PROJECTS["shop"] = "shopInGame";
    PROJECTS["metaShop"] = "metaShop";
    PROJECTS["shipyard"] = "shipyardInGame";
    PROJECTS["catalogue"] = "catalogueInGame";
})(PROJECTS || (PROJECTS = {}));
function goToWebProject(projectId, path = '') {
    return sendAction({
        actionId: 'goToWebProject',
        projectId,
        path,
    });
}

export { PROJECTS, goToWebProject };
//# sourceMappingURL=goToWebProject.js.map
